import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { IconWrapper } from 'client/ui/icon/IconWrapper';

export const IconTreeWrapper = styled(IconWrapper)`
  font-size: 16px;
  vertical-align: -0.2em;
`;
